module.exports = __webpack_public_path__ + "media/images/brand/original/MARQUESBRANDINGCO LOGO VERTICAL W-57fef3a39e46abcfc3b2abcc0c9e41a3.png";